import {
  PRODUCTS_ROUTE,
  EXPIRED_PRODUCTS_ROUTE,
  USERS_ROUTE,
  SETTINGS_ROUTE,
  ADMIN_STORES_ROUTE,
  ADMIN_USERS_ROUTE,
  ADMIN_IMPORT_ROUTE,
  ADMIN_EXPIRY_DATE_CONTROL_ROUTE,
  ADMIN_SETTINGS_ROUTE,
  SUPER_ADMIN_CLIENTS_ROUTE,
  SUPER_ADMIN_USERS_ROUTE
} from '../utils/Constants';

export const RoutesWithSidebar = () => {
  const routes = [
      PRODUCTS_ROUTE, 
      EXPIRED_PRODUCTS_ROUTE,
      USERS_ROUTE,
      SETTINGS_ROUTE,
      ADMIN_STORES_ROUTE,
      ADMIN_USERS_ROUTE,
      ADMIN_IMPORT_ROUTE,
      ADMIN_EXPIRY_DATE_CONTROL_ROUTE,
      ADMIN_SETTINGS_ROUTE,
      SUPER_ADMIN_CLIENTS_ROUTE,
      SUPER_ADMIN_USERS_ROUTE
    ]
  return routes;
}
